import { render } from "./SelfPayCases.vue?vue&type=template&id=78a9bc6d"
import script from "./SelfPayCases.vue?vue&type=script&lang=js"
export * from "./SelfPayCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/SelfPayCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78a9bc6d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78a9bc6d', __exports__)) {
    console.log('reload')
    api.reload('78a9bc6d', __exports__)
  }
  
  module.hot.accept("./SelfPayCases.vue?vue&type=template&id=78a9bc6d", () => {
    console.log('re-render')
    api.rerender('78a9bc6d', render)
  })

}


export default __exports__